import { APP_FRONT_ENV } from '@/config/base'

export function isDevMode(): boolean {
  return APP_FRONT_ENV !== 'PROD'
}

export function isLocalhost(): boolean {
  return window.location.hostname === 'localhost'
}
